<template>
  <div class="news-detail-page">
    <div class="sub-hero sub-hero-sm">
      <div class="sub-hero-inner">
        <div class="sub-breadcrumb"><a href="#/">首页</a> / <a href="#/news">展会资讯</a> / 详情</div>
        <h1 class="sub-title" v-if="article">{{ article.title }}</h1>
        <div class="sub-meta" v-if="article">
          <span class="sub-meta-item">📅 {{ article.month }} {{ article.day }}日</span>
          <span class="sub-meta-item">🏛 2026 安徽省养老博览会组委会</span>
        </div>
      </div>
    </div>
    <div class="sub-body">
      <div class="news-loading" v-if="loading">资讯加载中…</div>
      <article class="news-article" v-else-if="article">
        <div class="news-article-content">
          <p class="lead" v-if="article.desc">{{ article.desc }}</p>
          <div class="article-html" v-if="article.htmlContent" v-html="article.htmlContent"></div>
        </div>
        <div class="news-article-footer">
          <a href="#/news" class="news-back">← 返回资讯列表</a>
        </div>
      </article>
      <div v-else class="not-found">
        <h3>资讯不存在</h3>
        <p>您访问的资讯可能已被删除或不存在，请返回资讯列表查看其他内容。</p>
        <a href="#/news" class="btn btn-primary">返回资讯列表</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from "../api";

export default {
  name: 'NewsDetail',
  props: {
    id: { type: [String, Number], default: '' },
  },
  data() {
    return {
      loading: true,
      article: null,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.fetchDetail();
      },
    },
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      this.article = null;
      const { article } = await getArticleDetail(this.id);
      this.article = article;
      this.loading = false;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
  .news-detail-page { min-height: 100vh; background: #FBF7F1; color: var(--color-text); }
  .sub-hero {
    background: linear-gradient(135deg, #C25A2D 0%, #ed7b1a 55%, #f3d410 100%);
    color: #fff;
    padding: 140px 32px 96px;
    position: relative;
  }
  .sub-hero-sm { padding: 120px 32px 72px; }
  .sub-hero::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 30% 20%, rgba(255,255,255,0.25), transparent 55%);
    pointer-events: none;
  }
  .sub-hero-inner { max-width: 1000px; margin: 0 auto; position: relative; }
  .sub-breadcrumb { font-size: 14px; opacity: 0.9; margin-bottom: 20px; letter-spacing: 1px; }
  .sub-breadcrumb a { color: #fff; text-decoration: none; }
  .sub-breadcrumb a:hover { text-decoration: underline; }
  .sub-title { font-family: var(--font-serif); font-size: clamp(28px, 4vw, 40px); font-weight: 900; margin: 0 0 20px; line-height: 1.4; }
  .sub-meta { display: flex; flex-wrap: wrap; gap: 24px; font-size: 14px; opacity: 0.95; }
  .sub-meta-item { display: inline-flex; align-items: center; gap: 6px; }

  .sub-body { padding: 56px 32px 120px; }

  .news-article { max-width: 840px; margin: 0 auto; background: #fff; border-radius: var(--radius-lg); padding: 56px 64px; box-shadow: 0 4px 24px rgba(0,0,0,0.04); }
  .news-article-content .lead {
    font-size: 18px;
    line-height: 2;
    color: var(--color-text);
    background: linear-gradient(90deg, rgba(237, 123, 26, 0.08), transparent);
    border-left: 4px solid var(--color-primary);
    padding: 16px 24px;
    margin: 0 0 32px;
  }
  .news-article-content h2 {
    font-family: var(--font-serif);
    font-size: 26px;
    font-weight: 800;
    margin: 40px 0 20px;
    color: var(--color-text);
    position: relative;
    padding-left: 18px;
  }
  .news-article-content h2::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 5px;
    background: linear-gradient(180deg, var(--color-primary), var(--color-accent));
    border-radius: 3px;
  }
  .news-article-content p {
    font-size: 16px;
    line-height: 2;
    color: var(--color-text);
    margin: 16px 0;
  }
  .news-article-content ul {
    background: #FBF7F1;
    border-radius: var(--radius-md);
    padding: 24px 24px 24px 48px;
    margin: 16px 0;
  }
  .news-article-content ul li {
    font-size: 15px;
    line-height: 2.2;
    color: var(--color-text);
  }
  .article-html { font-size: 16px; line-height: 2; color: var(--color-text); }
  .article-html ::v-deep p { margin: 16px 0; }
  .article-html ::v-deep img { max-width: 100%; height: auto; border-radius: var(--radius-md); }
  .article-html ::v-deep h1,
  .article-html ::v-deep h2,
  .article-html ::v-deep h3 { font-family: var(--font-serif); font-weight: 800; margin: 28px 0 16px; line-height: 1.4; }
  .article-html ::v-deep h2 { font-size: 24px; }
  .article-html ::v-deep h3 { font-size: 20px; }
  .article-html ::v-deep a { color: var(--color-primary); }
  .news-loading { text-align: center; padding: 80px 24px; color: var(--color-text-light); font-size: 15px; }
  .news-article-footer { margin-top: 48px; padding-top: 24px; border-top: 1px solid var(--color-border); }
  .news-back { color: var(--color-primary); text-decoration: none; font-weight: 600; font-size: 14px; }
  .news-back:hover { text-decoration: underline; }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 16px 32px;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
  }
  .btn-primary {
    background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
    color: #fff;
    box-shadow: 0 8px 24px rgba(237, 123, 26, 0.28);
  }
  .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(237, 123, 26, 0.38); }
  .btn-arrow { transition: transform 0.3s ease; }
  .btn-primary:hover .btn-arrow { transform: translateX(4px); }

  .not-found {
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
    background: #fff;
    padding: 64px 48px;
    border-radius: var(--radius-lg);
  }
  .not-found h3 { font-size: 24px; margin: 0 0 12px; }
  .not-found p { color: var(--color-text-light); margin: 0 0 28px; line-height: 1.8; }

  @media (max-width: 640px) {
    .sub-hero { padding: 120px 24px 60px; }
    .sub-hero-sm { padding: 100px 24px 48px; }
    .sub-body { padding: 32px 16px 80px; }
    .news-article { padding: 32px 24px; }
    .news-article-content h2 { font-size: 20px; }
  }
</style>
